module.exports = __webpack_public_path__ + "img/capa_43.3706cf67.jpg";